// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "frontend-css/b38f395/" + chunkId + "-" + "cb21674d561c7921d2ad" + ".min.css";
};